const grid = document.getElementById("mgrid"),
  isMobile = () => window.innerWidth <= 800;

/*grid.addEventListener('mouseleave', () => {
  if (!isMobile())
    grid.classList.remove('active')
})*/

document
  .querySelectorAll(".nav-bar__linklist .categories a")
  .forEach((element) => {
    element.addEventListener("click", (el) => {
      el.preventDefault();
      active_categories = document.querySelectorAll(
        ".nav-bar__linklist .categories a.active"
      );

      active_categories.forEach((elem) => elem.classList.remove("active"));
      element.classList.add("active");

      if (!isMobile()) {
        document
          .querySelectorAll(".nav-bar__linklist .subcategory")
          .forEach((category) => {
            category.classList.remove("active");

            if (category.dataset.category === el.target.dataset.category)
              category.classList.add("active");
          });
      }
    });
  });

/*jQuery easy ticker v3.5.0 - (c) 2022 Aakash Chakravarthy*/
!(function (p, u) {
  var e = "easyTicker",
    d = {
      direction: "up",
      easing: "swing",
      speed: "slow",
      interval: 2e3,
      height: "auto",
      visible: 0,
      mousePause: !0,
      autoplay: !0,
      controls: {
        up: "",
        down: "",
        toggle: "",
        playText: "Play",
        stopText: "Stop",
      },
      callbacks: { before: !1, after: !1, finish: !1 },
    };
  function i(t, e) {
    var a = this;
    function i() {
      a.opts.autoplay && o();
    }
    function o() {
      0 == a.timer &&
        ((a.timer = setInterval(function () {
          s(a.opts.direction);
        }, a.opts.interval)),
        p(a.opts.controls.toggle)
          .addClass("et-run")
          .html(a.opts.controls.stopText));
    }
    function n() {
      clearInterval(a.timer),
        (a.timer = 0),
        p(a.opts.controls.toggle)
          .removeClass("et-run")
          .html(a.opts.controls.playText);
    }
    function s(t) {
      var e, i, o;
      if (!a.moving && a.elem.is(":visible")) {
        o =
          "up" == t
            ? ((e = ":first-child"), (i = "-="), "appendTo")
            : ((e = ":last-child"), (i = "+="), "prependTo");
        var n = a.targ.children(e),
          s = n.outerHeight();
        "function" == typeof a.opts.callbacks.before &&
          a.opts.callbacks.before.call(a, a.targ, n),
          (a.moving = !0),
          a.targ
            .stop(!0, !0)
            .animate(
              { top: i + s + "px" },
              a.opts.speed,
              a.opts.easing,
              function () {
                n.hide()[o](a.targ).fadeIn(),
                  a.targ.css("top", 0),
                  c(!0),
                  (a.moving = !1),
                  "function" == typeof a.opts.callbacks.after &&
                    a.opts.callbacks.after.call(a, a.targ, n);
              }
            );
      }
    }
    function l(t) {
      n(), s("up" == t ? "up" : "down");
    }
    function c(t) {
      var e, i, o, n, s;
      "auto" == a.opts.height &&
        (0 < a.opts.visible
          ? ((o = t),
            (n = 0),
            (s = "et-item-visible"),
            a.targ.children().removeClass(s),
            a.targ.children(":lt(" + a.opts.visible + ")").each(function () {
              (n += p(this).outerHeight()), p(this).addClass(s);
            }),
            o
              ? a.elem
                  .stop(!0, !0)
                  .animate({ height: n }, a.opts.speed, function () {
                    r();
                  })
              : a.elem.css("height", n))
          : ((e = 0),
            (i = a.elem.css("display")),
            a.elem.css("display", "block"),
            a.targ.children().each(function () {
              e += p(this).outerHeight();
            }),
            a.elem.css({ display: i, height: e }))),
        t || r();
    }
    function r() {
      "function" == typeof a.opts.callbacks.finish &&
        a.opts.callbacks.finish.call(a, a.targ);
    }
    return (
      (a.opts = p.extend({}, d, e)),
      (a.elem = p(t)),
      (a.targ = p(t).children(":first-child")),
      (a.timer = 0),
      (a.moving = !1),
      a.elem.children().css("margin", 0).children().css("margin", 0),
      a.elem.css({
        position: "relative",
        height: a.opts.height,
        overflow: "hidden",
      }),
      a.targ.css({ position: "absolute", margin: 0 }),
      c(!1),
      i(),
      (function () {
        var t, e;
        void 0 !== u.hidden
          ? ((t = "hidden"), (e = "visibilitychange"))
          : void 0 !== u.msHidden
          ? ((t = "msHidden"), (e = "msvisibilitychange"))
          : void 0 !== u.webkitHidden &&
            ((t = "webkitHidden"), (e = "webkitvisibilitychange"));
        u.addEventListener(
          e,
          function () {
            (u[t] ? n : i)();
          },
          !1
        );
      })(),
      a.opts.mousePause &&
        a.elem
          .on("mouseenter", function () {
            (a.timerTemp = a.timer), n();
          })
          .on("mouseleave", function () {
            0 !== a.timerTemp && i();
          }),
      p(a.opts.controls.up).on("click", function (t) {
        t.preventDefault(), l("up");
      }),
      p(a.opts.controls.down).on("click", function (t) {
        t.preventDefault(), l("down");
      }),
      p(a.opts.controls.toggle).on("click", function (t) {
        t.preventDefault(), (0 == a.timer ? i : n)();
      }),
      {
        up: function () {
          l("up");
        },
        down: function () {
          l("down");
        },
        start: o,
        stop: n,
        options: a.opts,
      }
    );
  }
  p.fn[e] = function (t) {
    return this.each(function () {
      p.data(this, e) || p.data(this, e, new i(this, t));
    });
  };
})(jQuery, (window, document));


// check header height
function checkHeaderHeight() {
  // select header element
  //const header = document.querySelector('.shopify-section__header');
  const abar = document.querySelector('.wdx-announcement-bar');

  // get rendered styles
  //const styles_header = window.getComputedStyle(header);
  const styles_abar = window.getComputedStyle(abar);

  // set header height rendered style
  const aBarHeight = styles_abar.height;
  // set CSS as a value
  document.documentElement.style.setProperty("--ab-height", aBarHeight);
}
addEventListener("resize", checkHeaderHeight);
addEventListener("orientationchange", checkHeaderHeight);
checkHeaderHeight();
